/**
 * Created by BlueFocus5 on 2016-11-07.
 */

import _ from 'lodash';
import { observable, autorun, action, toJS, computed, extendObservable, extendShallowObservable, map } from 'mobx';
import axios from 'axios';
import Locale from 'browser-locale';

class Dictionary {

   dictionary = observable.map({

   });

   dictionaryLoaded = false;

   // todo: LangSwitcher and this should have on source of langs list avaliable
   @observable dictionaryLang = {}
   @observable dictionaryLangsCode = observable.map({ });

   @observable currentLang = '';

   constructor(config) {

    this.config = config;
    let lang = Locale();

    if ( _.find(this.dictionaryLang, function(o,key) { return key == lang }) )
    {
      this.initLang(lang);
    }
    else
    {
      this.initLang("en");
    }

   }


  initLang = async(lang) =>
  {
    this.currentLang = lang;
    let result = await this.loadDictionary();

      _.map(result,(val,key)=>{

      this.dictionaryLangsCode.set(key,key);
    })


    this.dictionaryLang[lang] = _.clone(result);
    _.map(this.dictionaryLang[lang], (val, key) => {
      this.dictionary.set(key,val);
    })


  }

  @computed get getSelectedLang()  {
     return this.currentLang;
  }

  switchLang = async(lang) =>
  {

    if ( lang == '' ) return;


    this.currentLang = lang;

    let result = await this.loadDictionary();
    result = result[lang];


    _.map(result, (val, key) => {
      this.dictionary.set(key,val);

    })
  }

  @computed get getCurrentLangDict() {
    return this.dictionary;
   //return this.dictionary.currentLangTrans;
  }



  loadDictionary = async() => {
    return new Promise(async(resolve, reject) => {
      try {


        if ( this.dictionaryLoaded )
        {
            resolve( this.dictionaryLang);
        }
        else
        {


          const response = await axios.get(this.config.api +'dictionary');
          const data = response.data;
          this.dictionaryLoaded = true;
          this.dictionaryLang = data;

          resolve(data);
        }

      }
      catch (e) {

        reject(null);
      }
    });
  }

  /*

  loadTrans = (lang) => {
    this.dictionary.trans[lang] = {
    }
  }
  */

}


export default Dictionary;



